import { render, staticRenderFns } from "./LayoutContentVerticalNav.vue?vue&type=template&id=54ca11fc&scoped=true"
import script from "./LayoutContentVerticalNav.vue?vue&type=script&lang=js"
export * from "./LayoutContentVerticalNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentVerticalNav.vue?vue&type=style&index=0&id=54ca11fc&prod&lang=scss&scoped=true"
import style1 from "./LayoutContentVerticalNav.vue?vue&type=style&index=1&id=54ca11fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca11fc",
  null
  
)

export default component.exports